import { decode } from 'html-entities';
export const selectedSize = 18;
export const optionsSize = 18;
const icon = '&#x1F50D;&#xFE0E;';
export const searchPlaceholder = decode(icon) + 'Find a country';
export const customCountryCodeLabels = Object.freeze({
    AD: { primary: '+376', secondary: 'Andorra' },
    AE: { primary: '+971', secondary: 'United Arab Emirates' },
    AF: { primary: '+93', secondary: 'Afghanistan' },
    AG: { primary: '+1', secondary: 'Antigua and Barbuda' },
    AI: { primary: '+1', secondary: 'Anguilla' },
    AL: { primary: '+355', secondary: 'Albania' },
    AM: { primary: '+374', secondary: 'Armenia' },
    AO: { primary: '+244', secondary: 'Angola' },
    AR: { primary: '+54', secondary: 'Argentina' },
    AS: { primary: '+1', secondary: 'American Samoa' },
    AT: { primary: '+43', secondary: 'Austria' },
    AU: { primary: '+61', secondary: 'Australia' },
    AW: { primary: '+297', secondary: 'Aruba' },
    AZ: { primary: '+994', secondary: 'Azerbaijan' },
    BA: { primary: '+387', secondary: 'Bosnia and Herzegovina' },
    BB: { primary: '+1', secondary: 'Barbados' },
    BD: { primary: '+880', secondary: 'Bangladesh' },
    BE: { primary: '+32', secondary: 'Belgium' },
    BF: { primary: '+226', secondary: 'Burkina Faso' },
    BG: { primary: '+359', secondary: 'Bulgaria' },
    BH: { primary: '+973', secondary: 'Bahrain' },
    BI: { primary: '+257', secondary: 'Burundi' },
    BJ: { primary: '+229', secondary: 'Benin' },
    BM: { primary: '+1', secondary: 'Bermuda' },
    BO: { primary: '+591', secondary: 'Bolivia' },
    BR: { primary: '+55', secondary: 'Brazil' },
    BS: { primary: '+1', secondary: 'Bahamas' },
    BT: { primary: '+975', secondary: 'Bhutan' },
    BW: { primary: '+267', secondary: 'Botswana' },
    BY: { primary: '+375', secondary: 'Belarus' },
    BZ: { primary: '+501', secondary: 'Belize' },
    CA: { primary: '+1', secondary: 'Canada' },
    CD: {
        primary: '+243',
        secondary: 'Congo, The Democratic Republic of the',
    },
    CF: { primary: '+236', secondary: 'Central African Republic' },
    CG: { primary: '+242', secondary: 'Congo' },
    CH: { primary: '+41', secondary: 'Switzerland' },
    CI: { primary: '+225', secondary: 'Cote d Ivoire' },
    CK: { primary: '+682', secondary: 'Cook Islands' },
    CL: { primary: '+56', secondary: 'Chile' },
    CM: { primary: '+237', secondary: 'Cameroon' },
    CN: { primary: '+86', secondary: 'China' },
    CO: { primary: '+57', secondary: 'Colombia' },
    CR: { primary: '+506', secondary: 'Costa Rica' },
    CU: { primary: '+53', secondary: 'Cuba' },
    CV: { primary: '+238', secondary: 'Cabo Verde' },
    CW: { primary: '+599', secondary: 'Curacao' },
    CY: { primary: '+357', secondary: 'Cyprus' },
    CZ: { primary: '+420', secondary: 'Czechia' },
    DE: { primary: '+49', secondary: 'Germany' },
    DJ: { primary: '+253', secondary: 'Djibouti' },
    DK: { primary: '+45', secondary: 'Denmark' },
    DM: { primary: '+1', secondary: 'Dominica' },
    DO: { primary: '+1', secondary: 'Dominican Republic' },
    DZ: { primary: '+213', secondary: 'Algeria' },
    EC: { primary: '+593', secondary: 'Ecuador' },
    EE: { primary: '+372', secondary: 'Estonia' },
    EG: { primary: '+20', secondary: 'Egypt' },
    ER: { primary: '+291', secondary: 'Eritrea' },
    ES: { primary: '+34', secondary: 'Spain' },
    ET: { primary: '+251', secondary: 'Ethiopia' },
    FI: { primary: '+358', secondary: 'Finland' },
    FJ: { primary: '+679', secondary: 'Fiji' },
    FK: { primary: '+500', secondary: 'Falkland Islands (Malvinas)' },
    FM: {
        primary: '+691',
        secondary: 'Micronesia, Federated States of',
    },
    FO: { primary: '+298', secondary: 'Faroe Islands' },
    FR: { primary: '+33', secondary: 'France' },
    GA: { primary: '+241', secondary: 'Gabon' },
    GB: { primary: '+44', secondary: 'United Kingdom' },
    GD: { primary: '+1', secondary: 'Grenada' },
    GE: { primary: '+995', secondary: 'Georgia' },
    GG: { primary: '+44', secondary: 'Guernsey' },
    GH: { primary: '+233', secondary: 'Ghana' },
    GI: { primary: '+350', secondary: 'Gibraltar' },
    GL: { primary: '+299', secondary: 'Greenland' },
    GM: { primary: '+220', secondary: 'Gambia' },
    GN: { primary: '+224', secondary: 'Guinea' },
    GQ: { primary: '+240', secondary: 'Equatorial Guinea' },
    GR: { primary: '+30', secondary: 'Greece' },
    GT: { primary: '+502', secondary: 'Guatemala' },
    GU: { primary: '+1', secondary: 'Guam' },
    GW: { primary: '+245', secondary: 'Guinea-Bissau' },
    HK: { primary: '+852', secondary: 'Hong Kong' },
    HN: { primary: '+504', secondary: 'Honduras' },
    HR: { primary: '+385', secondary: 'Croatia' },
    HT: { primary: '+509', secondary: 'Haiti' },
    HU: { primary: '+36', secondary: 'Hungary' },
    ID: { primary: '+62', secondary: 'Indonesia' },
    IE: { primary: '+353', secondary: 'Ireland' },
    IL: { primary: '+972', secondary: 'Israel' },
    IM: { primary: '+44', secondary: 'Isle of Man' },
    IN: { primary: '+91', secondary: 'India' },
    IO: { primary: '+246', secondary: 'British Indian Ocean Territory' },
    IQ: { primary: '+964', secondary: 'Iraq' },
    IR: { primary: '+98', secondary: 'Iran, Islamic  Republic of' },
    IS: { primary: '+354', secondary: 'Iceland' },
    IT: { primary: '+39', secondary: 'Italy' },
    JE: { primary: '+44', secondary: 'Jersey' },
    JM: { primary: '+1', secondary: 'Jamaica' },
    JO: { primary: '+962', secondary: 'Jordan' },
    JP: { primary: '+81', secondary: 'Japan' },
    KE: { primary: '+254', secondary: 'Kenya' },
    KG: { primary: '+996', secondary: 'Kyrgyzstan' },
    KH: { primary: '+855', secondary: 'Cambodia' },
    KI: { primary: '+686', secondary: 'Kiribati' },
    KM: { primary: '+269', secondary: 'Comoros' },
    KN: { primary: '+1', secondary: 'Saint Kitts and Nevis' },
    KP: {
        primary: '+850',
        secondary: 'Korea, Democratic Peoples Republic of',
    },
    KR: { primary: '+82', secondary: 'Korea, Republic of' },
    KW: { primary: '+965', secondary: 'Kuwait' },
    KY: { primary: '+1', secondary: 'Cayman Islands' },
    KZ: { primary: '+7', secondary: 'Kazakhstan' },
    LA: {
        primary: '+856',
        secondary: 'Lao, Peoples Democratic Republic',
    },
    LB: { primary: '+961', secondary: 'Lebanon' },
    LC: { primary: '+1', secondary: 'Saint Lucia' },
    LI: { primary: '+423', secondary: 'Liechtenstein' },
    LK: { primary: '+94', secondary: 'Sri Lanka' },
    LR: { primary: '+231', secondary: 'Liberia' },
    LS: { primary: '+266', secondary: 'Lesotho' },
    LT: { primary: '+370', secondary: 'Lithuania' },
    LU: { primary: '+352', secondary: 'Luxembourg' },
    LV: { primary: '+371', secondary: 'Latvia' },
    LY: { primary: '+218', secondary: 'Libya' },
    MA: { primary: '+212', secondary: 'Morocco' },
    MC: { primary: '+377', secondary: 'Monaco' },
    MD: { primary: '+373', secondary: 'Moldova' },
    ME: { primary: '+382', secondary: 'Montenegro' },
    MG: { primary: '+261', secondary: 'Madagascar' },
    MH: { primary: '+692', secondary: 'Marshall Islands' },
    MK: { primary: '+389', secondary: 'North Macedonia' },
    ML: { primary: '+223', secondary: 'Mali' },
    MM: { primary: '+95', secondary: 'Myanmar' },
    MN: { primary: '+976', secondary: 'Mongolia' },
    MO: { primary: '+853', secondary: 'Macao' },
    MP: { primary: '+1', secondary: 'Northern Mariana Islands' },
    MQ: { primary: '+596', secondary: 'Martinique' },
    MR: { primary: '+222', secondary: 'Mauritania' },
    MS: { primary: '+1', secondary: 'Montserrat' },
    MT: { primary: '+356', secondary: 'Malta' },
    MU: { primary: '+230', secondary: 'Mauritius' },
    MV: { primary: '+960', secondary: 'Maldives' },
    MW: { primary: '+265', secondary: 'Malawi' },
    MX: { primary: '+52', secondary: 'Mexico' },
    MY: { primary: '+60', secondary: 'Malaysia' },
    MZ: { primary: '+258', secondary: 'Mozambique' },
    NA: { primary: '+264', secondary: 'Namibia' },
    NE: { primary: '+227', secondary: 'Niger' },
    NF: { primary: '+672', secondary: 'Norfolk Island' },
    NG: { primary: '+234', secondary: 'Nigeria' },
    NI: { primary: '+505', secondary: 'Nicaragua' },
    NL: { primary: '+31', secondary: 'Netherlands' },
    NO: { primary: '+47', secondary: 'Norway' },
    NP: { primary: '+977', secondary: 'Nepal' },
    NR: { primary: '+674', secondary: 'Nauru' },
    NU: { primary: '+683', secondary: 'Niue' },
    NZ: { primary: '+64', secondary: 'New Zealand' },
    OM: { primary: '+968', secondary: 'Oman' },
    PA: { primary: '+507', secondary: 'Panama' },
    PE: { primary: '+51', secondary: 'Peru' },
    PF: { primary: '+689', secondary: 'French Polynesia' },
    PG: { primary: '+675', secondary: 'Papua New Guinea' },
    PH: { primary: '+63', secondary: 'Philippines' },
    PK: { primary: '+92', secondary: 'Pakistan' },
    PL: { primary: '+48', secondary: 'Poland' },
    PN: { primary: '+64', secondary: 'Pitcairn' },
    PR: { primary: '+1', secondary: 'Puerto Rico' },
    PS: { primary: '+970', secondary: 'Palestine, State of' },
    PT: { primary: '+351', secondary: 'Portugal' },
    PW: { primary: '+680', secondary: 'Palau' },
    PY: { primary: '+595', secondary: 'Paraguay' },
    QA: { primary: '+974', secondary: 'Qatar' },
    RO: { primary: '+40', secondary: 'Romania' },
    RS: { primary: '+381', secondary: 'Serbia' },
    RU: { primary: '+7', secondary: 'Russian Federation' },
    RW: { primary: '+250', secondary: 'Rwanda' },
    SA: { primary: '+966', secondary: 'Saudi Arabia' },
    SB: { primary: '+677', secondary: 'Solomon Islands' },
    SC: { primary: '+248', secondary: 'Seychelles' },
    SD: { primary: '+249', secondary: 'Sudan' },
    SE: { primary: '+46', secondary: 'Sweden' },
    SG: { primary: '+65', secondary: 'Singapore' },
    SI: { primary: '+386', secondary: 'Slovenia' },
    SK: { primary: '+421', secondary: 'Slovakia' },
    SL: { primary: '+232', secondary: 'Sierra Leone' },
    SM: { primary: '+378', secondary: 'San Marino' },
    SN: { primary: '+221', secondary: 'Senegal' },
    SO: { primary: '+252', secondary: 'Somalia' },
    SR: { primary: '+597', secondary: 'Suriname' },
    SS: { primary: '+211', secondary: 'South Sudan' },
    ST: { primary: '+239', secondary: 'Sao Tome and Principe' },
    SV: { primary: '+503', secondary: 'El Salvador' },
    SX: { primary: '+1', secondary: 'Sint Maarten(Dutch part)' },
    SY: { primary: '+963', secondary: 'Syrian Arab Republic' },
    SZ: { primary: '+268', secondary: 'Eswatini' },
    TC: { primary: '+1', secondary: 'Turks and Caicos Islands' },
    TD: { primary: '+235', secondary: 'Chad' },
    TG: { primary: '+228', secondary: 'Togo' },
    TH: { primary: '+66', secondary: 'Thailand' },
    TJ: { primary: '+992', secondary: 'Tajikistan' },
    TK: { primary: '+690', secondary: 'Tokelau' },
    TM: { primary: '+993', secondary: 'Turkmenistan' },
    TN: { primary: '+216', secondary: 'Tunisia' },
    TO: { primary: '+676', secondary: 'Tonga' },
    TR: { primary: '+90', secondary: 'Turkey' },
    TT: { primary: '+1', secondary: 'Trinidad and Tobago' },
    TV: { primary: '+688', secondary: 'Tuvalu' },
    TW: { primary: '+886', secondary: 'Taiwan' },
    TZ: { primary: '+255', secondary: 'Tanzania' },
    UA: { primary: '+380', secondary: 'Ukraine' },
    UG: { primary: '+256', secondary: 'Uganda' },
    US: { primary: '+1', secondary: 'United States' },
    UY: { primary: '+598', secondary: 'Uruguay' },
    UZ: { primary: '+998', secondary: 'Uzbekistan' },
    VE: { primary: '+58', secondary: 'Venezuela' },
    VI: { primary: '+1', secondary: 'Virgin Islands,U.S.' },
    VN: { primary: '+84', secondary: 'Vietnam' },
    VU: { primary: '+678', secondary: 'Vanuatu' },
    WS: { primary: '+685', secondary: 'Samoa' },
    YE: { primary: '+967', secondary: 'Yemen' },
    ZA: { primary: '+27', secondary: 'South Africa' },
    ZM: { primary: '+260', secondary: 'Zambia' },
    ZW: { primary: '+263', secondary: 'Zimbabwe' },
});
export const customLabels = Object.freeze({
    AD: { primary: '', secondary: 'Andorra' },
    AE: { primary: '', secondary: 'United Arab Emirates' },
    AF: { primary: '', secondary: 'Afghanistan' },
    AG: { primary: '', secondary: 'Antigua and Barbuda' },
    AI: { primary: '', secondary: 'Anguilla' },
    AL: { primary: '', secondary: 'Albania' },
    AM: { primary: '', secondary: 'Armenia' },
    AO: { primary: '', secondary: 'Angola' },
    AR: { primary: '', secondary: 'Argentina' },
    AS: { primary: '', secondary: 'American Samoa' },
    AT: { primary: '', secondary: 'Austria' },
    AU: { primary: '', secondary: 'Australia' },
    AW: { primary: '', secondary: 'Aruba' },
    AZ: { primary: '', secondary: 'Azerbaijan' },
    BA: { primary: '', secondary: 'Bosnia and Herzegovina' },
    BB: { primary: '', secondary: 'Barbados' },
    BD: { primary: '', secondary: 'Bangladesh' },
    BE: { primary: '', secondary: 'Belgium' },
    BF: { primary: '', secondary: 'Burkina Faso' },
    BG: { primary: '', secondary: 'Bulgaria' },
    BH: { primary: '', secondary: 'Bahrain' },
    BI: { primary: '', secondary: 'Burundi' },
    BJ: { primary: '', secondary: 'Benin' },
    BM: { primary: '', secondary: 'Bermuda' },
    BO: { primary: '', secondary: 'Bolivia' },
    BR: { primary: '', secondary: 'Brazil' },
    BS: { primary: '', secondary: 'Bahamas' },
    BT: { primary: '', secondary: 'Bhutan' },
    BW: { primary: '', secondary: 'Botswana' },
    BY: { primary: '', secondary: 'Belarus' },
    BZ: { primary: '', secondary: 'Belize' },
    CA: { primary: '', secondary: 'Canada' },
    CD: {
        primary: '',
        secondary: 'Congo, The Democratic Republic of the',
    },
    CF: { primary: '', secondary: 'Central African Republic' },
    CG: { primary: '', secondary: 'Congo' },
    CH: { primary: '', secondary: 'Switzerland' },
    CI: { primary: '', secondary: 'Cote d Ivoire' },
    CK: { primary: '', secondary: 'Cook Islands' },
    CL: { primary: '', secondary: 'Chile' },
    CM: { primary: '', secondary: 'Cameroon' },
    CN: { primary: '', secondary: 'China' },
    CO: { primary: '', secondary: 'Colombia' },
    CR: { primary: '', secondary: 'Costa Rica' },
    CU: { primary: '', secondary: 'Cuba' },
    CV: { primary: '', secondary: 'Cabo Verde' },
    CW: { primary: '', secondary: 'Curacao' },
    CY: { primary: '', secondary: 'Cyprus' },
    CZ: { primary: '', secondary: 'Czechia' },
    DE: { primary: '', secondary: 'Germany' },
    DJ: { primary: '', secondary: 'Djibouti' },
    DK: { primary: '', secondary: 'Denmark' },
    DM: { primary: '', secondary: 'Dominica' },
    DO: { primary: '', secondary: 'Dominican Republic' },
    DZ: { primary: '', secondary: 'Algeria' },
    EC: { primary: '', secondary: 'Ecuador' },
    EE: { primary: '', secondary: 'Estonia' },
    EG: { primary: '', secondary: 'Egypt' },
    ER: { primary: '', secondary: 'Eritrea' },
    ES: { primary: '', secondary: 'Spain' },
    ET: { primary: '', secondary: 'Ethiopia' },
    FI: { primary: '', secondary: 'Finland' },
    FJ: { primary: '', secondary: 'Fiji' },
    FK: { primary: '', secondary: 'Falkland Islands (Malvinas)' },
    FM: {
        primary: '',
        secondary: 'Micronesia, Federated States of',
    },
    FO: { primary: '', secondary: 'Faroe Islands' },
    FR: { primary: '', secondary: 'France' },
    GA: { primary: '', secondary: 'Gabon' },
    GB: { primary: '', secondary: 'United Kingdom' },
    GD: { primary: '', secondary: 'Grenada' },
    GE: { primary: '', secondary: 'Georgia' },
    GG: { primary: '', secondary: 'Guernsey' },
    GH: { primary: '', secondary: 'Ghana' },
    GI: { primary: '', secondary: 'Gibraltar' },
    GL: { primary: '', secondary: 'Greenland' },
    GM: { primary: '', secondary: 'Gambia' },
    GN: { primary: '', secondary: 'Guinea' },
    GQ: { primary: '', secondary: 'Equatorial Guinea' },
    GR: { primary: '', secondary: 'Greece' },
    GT: { primary: '', secondary: 'Guatemala' },
    GU: { primary: '', secondary: 'Guam' },
    GW: { primary: '', secondary: 'Guinea-Bissau' },
    HK: { primary: '', secondary: 'Hong Kong' },
    HN: { primary: '', secondary: 'Honduras' },
    HR: { primary: '', secondary: 'Croatia' },
    HT: { primary: '', secondary: 'Haiti' },
    HU: { primary: '', secondary: 'Hungary' },
    ID: { primary: '', secondary: 'Indonesia' },
    IE: { primary: '', secondary: 'Ireland' },
    IL: { primary: '', secondary: 'Israel' },
    IM: { primary: '', secondary: 'Isle of Man' },
    IN: { primary: '', secondary: 'India' },
    IO: { primary: '', secondary: 'British Indian Ocean Territory' },
    IQ: { primary: '', secondary: 'Iraq' },
    IR: { primary: '', secondary: 'Iran, Islamic  Republic of' },
    IS: { primary: '', secondary: 'Iceland' },
    IT: { primary: '', secondary: 'Italy' },
    JE: { primary: '', secondary: 'Jersey' },
    JM: { primary: '', secondary: 'Jamaica' },
    JO: { primary: '', secondary: 'Jordan' },
    JP: { primary: '', secondary: 'Japan' },
    KE: { primary: '', secondary: 'Kenya' },
    KG: { primary: '', secondary: 'Kyrgyzstan' },
    KH: { primary: '', secondary: 'Cambodia' },
    KI: { primary: '', secondary: 'Kiribati' },
    KM: { primary: '', secondary: 'Comoros' },
    KN: { primary: '', secondary: 'Saint Kitts and Nevis' },
    KP: {
        primary: '',
        secondary: 'Korea, Democratic Peoples Republic of',
    },
    KR: { primary: '', secondary: 'Korea, Republic of' },
    KW: { primary: '', secondary: 'Kuwait' },
    KY: { primary: '', secondary: 'Cayman Islands' },
    KZ: { primary: '', secondary: 'Kazakhstan' },
    LA: {
        primary: '',
        secondary: 'Lao, Peoples Democratic Republic',
    },
    LB: { primary: '', secondary: 'Lebanon' },
    LC: { primary: '', secondary: 'Saint Lucia' },
    LI: { primary: '', secondary: 'Liechtenstein' },
    LK: { primary: '', secondary: 'Sri Lanka' },
    LR: { primary: '', secondary: 'Liberia' },
    LS: { primary: '', secondary: 'Lesotho' },
    LT: { primary: '', secondary: 'Lithuania' },
    LU: { primary: '', secondary: 'Luxembourg' },
    LV: { primary: '', secondary: 'Latvia' },
    LY: { primary: '', secondary: 'Libya' },
    MA: { primary: '', secondary: 'Morocco' },
    MC: { primary: '', secondary: 'Monaco' },
    MD: { primary: '', secondary: 'Moldova' },
    ME: { primary: '', secondary: 'Montenegro' },
    MG: { primary: '', secondary: 'Madagascar' },
    MH: { primary: '', secondary: 'Marshall Islands' },
    MK: { primary: '', secondary: 'North Macedonia' },
    ML: { primary: '', secondary: 'Mali' },
    MM: { primary: '', secondary: 'Myanmar' },
    MN: { primary: '', secondary: 'Mongolia' },
    MO: { primary: '', secondary: 'Macao' },
    MP: { primary: '', secondary: 'Northern Mariana Islands' },
    MQ: { primary: '', secondary: 'Martinique' },
    MR: { primary: '', secondary: 'Mauritania' },
    MS: { primary: '', secondary: 'Montserrat' },
    MT: { primary: '', secondary: 'Malta' },
    MU: { primary: '', secondary: 'Mauritius' },
    MV: { primary: '', secondary: 'Maldives' },
    MW: { primary: '', secondary: 'Malawi' },
    MX: { primary: '', secondary: 'Mexico' },
    MY: { primary: '', secondary: 'Malaysia' },
    MZ: { primary: '', secondary: 'Mozambique' },
    NA: { primary: '', secondary: 'Namibia' },
    NE: { primary: '', secondary: 'Niger' },
    NF: { primary: '', secondary: 'Norfolk Island' },
    NG: { primary: '', secondary: 'Nigeria' },
    NI: { primary: '', secondary: 'Nicaragua' },
    NL: { primary: '', secondary: 'Netherlands' },
    NO: { primary: '', secondary: 'Norway' },
    NP: { primary: '', secondary: 'Nepal' },
    NR: { primary: '', secondary: 'Nauru' },
    NU: { primary: '', secondary: 'Niue' },
    NZ: { primary: '', secondary: 'New Zealand' },
    OM: { primary: '', secondary: 'Oman' },
    PA: { primary: '', secondary: 'Panama' },
    PE: { primary: '', secondary: 'Peru' },
    PF: { primary: '', secondary: 'French Polynesia' },
    PG: { primary: '', secondary: 'Papua New Guinea' },
    PH: { primary: '', secondary: 'Philippines' },
    PK: { primary: '', secondary: 'Pakistan' },
    PL: { primary: '', secondary: 'Poland' },
    PN: { primary: '', secondary: 'Pitcairn' },
    PR: { primary: '', secondary: 'Puerto Rico' },
    PS: { primary: '', secondary: 'Palestine, State of' },
    PT: { primary: '', secondary: 'Portugal' },
    PW: { primary: '', secondary: 'Palau' },
    PY: { primary: '', secondary: 'Paraguay' },
    QA: { primary: '', secondary: 'Qatar' },
    RO: { primary: '', secondary: 'Romania' },
    RS: { primary: '', secondary: 'Serbia' },
    RU: { primary: '', secondary: 'Russian Federation' },
    RW: { primary: '', secondary: 'Rwanda' },
    SA: { primary: '', secondary: 'Saudi Arabia' },
    SB: { primary: '', secondary: 'Solomon Islands' },
    SC: { primary: '', secondary: 'Seychelles' },
    SD: { primary: '', secondary: 'Sudan' },
    SE: { primary: '', secondary: 'Sweden' },
    SG: { primary: '', secondary: 'Singapore' },
    SI: { primary: '', secondary: 'Slovenia' },
    SK: { primary: '', secondary: 'Slovakia' },
    SL: { primary: '', secondary: 'Sierra Leone' },
    SM: { primary: '', secondary: 'San Marino' },
    SN: { primary: '', secondary: 'Senegal' },
    SO: { primary: '', secondary: 'Somalia' },
    SR: { primary: '', secondary: 'Suriname' },
    SS: { primary: '', secondary: 'South Sudan' },
    ST: { primary: '', secondary: 'Sao Tome and Principe' },
    SV: { primary: '', secondary: 'El Salvador' },
    SX: { primary: '', secondary: 'Sint Maarten(Dutch part)' },
    SY: { primary: '', secondary: 'Syrian Arab Republic' },
    SZ: { primary: '', secondary: 'Eswatini' },
    TC: { primary: '', secondary: 'Turks and Caicos Islands' },
    TD: { primary: '', secondary: 'Chad' },
    TG: { primary: '', secondary: 'Togo' },
    TH: { primary: '', secondary: 'Thailand' },
    TJ: { primary: '', secondary: 'Tajikistan' },
    TK: { primary: '', secondary: 'Tokelau' },
    TM: { primary: '', secondary: 'Turkmenistan' },
    TN: { primary: '', secondary: 'Tunisia' },
    TO: { primary: '', secondary: 'Tonga' },
    TR: { primary: '', secondary: 'Turkey' },
    TT: { primary: '', secondary: 'Trinidad and Tobago' },
    TV: { primary: '', secondary: 'Tuvalu' },
    TW: { primary: '', secondary: 'Taiwan' },
    TZ: { primary: '', secondary: 'Tanzania' },
    UA: { primary: '', secondary: 'Ukraine' },
    UG: { primary: '', secondary: 'Uganda' },
    US: { primary: '', secondary: 'United States' },
    UY: { primary: '', secondary: 'Uruguay' },
    UZ: { primary: '', secondary: 'Uzbekistan' },
    VE: { primary: '', secondary: 'Venezuela' },
    VI: { primary: '', secondary: 'Virgin Islands,U.S.' },
    VN: { primary: '', secondary: 'Vietnam' },
    VU: { primary: '', secondary: 'Vanuatu' },
    WS: { primary: '', secondary: 'Samoa' },
    YE: { primary: '', secondary: 'Yemen' },
    ZA: { primary: '', secondary: 'South Africa' },
    ZM: { primary: '', secondary: 'Zambia' },
    ZW: { primary: '', secondary: 'Zimbabwe' },
});
